module.exports = __webpack_public_path__ + "static/media/step-5-note.d3e68841.gif";